import { units, getValidUnitsForType } from '../../../../units';

export const schema = {
  type: 'object',
  properties: {
    title: {
      type: 'string',
      title: 'Title',
    },
    unit: {
      type: 'string',
      title: 'Unit',
      default: units[0].id,
      oneOf: getValidUnitsForType('pie').map((unit) => ({
        enum: [unit.id],
        title: `${unit.category}: ${unit.name}`,
      })),
      description: 'Automatic unit conversion (e.g., kW to MW) is applied to default signal units',
    },
    unitLabel: {
      type: 'string',
      title: 'Custom unit label',
      description: 'This takes precedence over Unit',
    },
    decimals: {
      default: 'auto',
      title: 'Decimals',
      type: 'string',
      enum: ['auto', '0', '1', '2', '3', '4', '5'],
    },
    pieType: {
      title: 'Pie type',
      type: 'string',
      enum: ['Solid', 'Hollow'],
      default: 'Solid',
    },
    sliceGap: {
      title: 'Slice gap',
      type: 'number',
      default: 0,
      minimum: 0,
      maximum: 15,
    },
    legend: {
      type: 'object',
      title: 'Legend',
      properties: {
        show: { type: 'boolean', default: false },
      },
    },
  },
};

export const uiSchema = {
  unit: {
    'ui:field': 'customUnitLabel',
  },
  unitLabel: {
    'ui:field': 'customUnitLabel',
  },
  sliceGap: {
    'ui:widget': 'range',
  },
};

export const getSchema = () => schema;
